// Re-export the validation schemas from database.ts
export { insertProjectSchema, updateTicketSchema, insertTicketSchema, insertUserSchema, insertUserSettingsSchema, insertPlanSchema, insertDocumentSchema, insertGewerkSchema, insertTypSchema, insertStatusSchema, insertTeamSchema, insertTeamGroupSchema, insertPrioritySchema, insertPositionSchema, insertOrganizationSchema, insertSubscriptionSchema, insertBillingHistorySchema, insertSupportMessageSchema, insertInvoiceTemplateSchema, insertTicketHistorySchema, insertWeatherWarningSchema, insertImageAnalysisSchema, insertTicketChatMessageSchema, insertBauzeitenplanSchema, insertBauzeitenplanColumnWidthsSchema } from './database.js';
import { z } from "zod";
// Additional API-specific validation schemas
export const loginSchema = z.object({
    username: z.string().min(1),
    password: z.string().min(1),
});
export const registerSchema = z.object({
    username: z.string().min(3).max(20),
    email: z.string().email(),
    password: z.string().min(6).max(50),
    firstName: z.string().min(1),
    lastName: z.string().min(1),
    displayName: z.string().optional(),
    phone: z.string().optional(),
});
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1),
    newPassword: z.string().min(6).max(50),
});
// API Response Schemas
export const apiSuccessSchema = z.object({
    success: z.literal(true),
    message: z.string().optional(),
    data: z.any().optional(),
});
export const apiErrorSchema = z.object({
    success: z.literal(false),
    message: z.string(),
    error: z.string().optional(),
    errors: z.array(z.any()).optional(),
});
// Pagination Schema
export const paginationSchema = z.object({
    page: z.number().min(1).default(1),
    limit: z.number().min(1).max(100).default(20),
    sortBy: z.string().optional(),
    sortDirection: z.enum(['asc', 'desc']).default('desc'),
    search: z.string().optional(),
});
